export const DeductionsColumn = [
    "EmployeeCode",
    "MessAmount",
    "OthersAmount"
]




